module.exports = __webpack_public_path__ + "img/ps-sabadosfa.ff707791.jpg";